import { isoToFormatDate } from "./formatTime";
const { DateTime } = require("luxon");

const getRole = (user) => {
  if (user.isRenter) {
    return "住戶";
  } else {
    return "非住戶";
  }
};

const getRentDate = (user) => {
  if (user.rentStartDate) {
    return `${isoToFormatDate(user.rentStartDate)} - ${isoToFormatDate(user.rentEndDate)}`;
  } else {
    return "";
  }
};

// add field containing shown text to be searched
const addSearchedField = (users) => {
  users.forEach((user) => {
    const shownText = [getRole(user), getRentDate(user)];

    user.searchedField = shownText.join(" ");
  });
};

const sortByMemberNumber = (users) => {
  users.sort((a, b) => b.memberNumber.localeCompare(a.memberNumber));
};

// return if a user is renter by its rent date
const isRenter = (user) => {
  if (user.rentStartDate === null || user.rentEndDate === null) {
    return false;
  }

  // today midnight in utc+8
  const now = DateTime.now().setZone("Asia/Shanghai");
  const todayMidnight = now.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const startDate = DateTime.fromISO(user.rentStartDate);
  const endDate = DateTime.fromISO(user.rentEndDate);

  const rentNotStarted = startDate.diff(todayMidnight, ["seconds"]).seconds > 0; // start date if after today
  const rentIsDue = endDate.diff(todayMidnight, ["seconds"]).seconds < 0; // end Date is before today

  return !rentNotStarted && !rentIsDue;
};

export { getRole, getRentDate, addSearchedField, sortByMemberNumber, isRenter };
